//react, npm imports
import axios from "axios";
import React from "react";
import store from "../Redux/store";
import base64 from "base-64";

//constants / utils/ actions
import getAppErrorInfo from "./ErrorLookUp"; // App ERROR INFO
import { getAPIErrorInfo } from "./ErrorLookUp"; // API info
import { OperationStatus, HttpStatus } from "./Constants";
import { VERIFY_OTP_ACTION } from "../Components/OtpVerification/Constants";
import {
  LOGIN_ACTION,
  GET_REFRESH_TOKEN,
  GOOGLE_SIGNUP_ACTION,
} from "../Components/Login/Constants";
import { CREATE_TRANSACTION_V2, GET_SUBSCRIPTION_TRANSACTION_HISTORY, GET_USER_MAPPING_LIST, SUBSCRIPTION_PAY, GET_PRODUCT_PLAN_INFO, UNSUBSCRIBE_SUBSCRIPTION, GET_PAYMENT_METHODS } from "../Components/Plans/Constants";
import { GET_ACCESS_TOKEN_ACTION } from "../Components/UpgradeHandler/Constants";

export default class BaseCommunication extends React.Component {
  constructor(...props) {
    super(...props);
    this.anonymousApis = [LOGIN_ACTION];
  }
  callAPI(action, url, httpMethod, requestBody, callback) {
    this.callActualAPI(
      action,
      {
        //baseURL: API_BASE_URL,
        url: url,
        method: httpMethod,
        data: httpMethod !== "GET" ? requestBody : null,
        params: httpMethod === "GET" ? requestBody : null,
        //withCredentials: true
      },
      callback
    );
  }

  callActualAPI(action, apiConfig, callback) {
    if (this.isNotAnonymousApi(action)) {
      /* headers */
      if (action === VERIFY_OTP_ACTION || action === GOOGLE_SIGNUP_ACTION) {
        apiConfig.headers = {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization:
            "Basic " +
            base64.encode(
              process.env.REACT_APP_CLIENT_ID+":"+process.env.REACT_APP_CLIENT_SECRET_KEY            ),
        };
      } else if (action === GET_REFRESH_TOKEN) {
        let requestFormBody = [];
        for (let property in apiConfig.data) {
          let encodedKey = encodeURIComponent(property);
          let encodedValue = encodeURIComponent(apiConfig.data[property]);
          requestFormBody.push(encodedKey + "=" + encodedValue);
        }
        requestFormBody = requestFormBody.join("&");
        apiConfig.data = requestFormBody;
        apiConfig.headers = {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization:
            "Basic " +
            base64.encode(
              process.env.REACT_APP_CLIENT_ID+":"+process.env.REACT_APP_CLIENT_SECRET_KEY            ),
        };
      } else if (
        action === GET_SUBSCRIPTION_TRANSACTION_HISTORY || 
        action === GET_ACCESS_TOKEN_ACTION || 
        action === CREATE_TRANSACTION_V2 || 
        action === SUBSCRIPTION_PAY || 
        action === GET_PRODUCT_PLAN_INFO ||
        action === GET_USER_MAPPING_LIST ||
        action === UNSUBSCRIBE_SUBSCRIPTION ||
        action === GET_PAYMENT_METHODS
        ) {
        if(!store.getState().UpgradeHandler.userAccessTokenInfo) {
          console.log(`ERORR IN API CALLING`);
        }
        else {
          apiConfig.headers = {
            "Content-Type": "application/json",
            Authorization:
              "Bearer " +
              store.getState().UpgradeHandler.userAccessTokenInfo.accessToken,
          };
        }
      } else {
        /**
         * This is quick code is added to support invitation flow. Currently access token is used from OTP
         * handlder. In invitation flow we get token in invitation handler,
         * rather than OTP handler. So if access token in missing in OTP handler we are using it from
         * Invitation handler.
         */
        if (
          (!store.getState().OtpVerification.currentUserInfo ||
            !store.getState().OtpVerification.currentUserInfo.accessToken) &&
          (!store.getState().Login.currentUserInfo ||
            !store.getState().Login.currentUserInfo.accessToken)
        ) {
          store.getState().OtpVerification.currentUserInfo = null;
          store.getState().Login.currentUserInfo = null;
          apiConfig.headers = {
            "Content-Type": "application/json",
            Authorization:
              "Bearer " +
              store.getState().InvitationHandler.accessInfo.accessToken,
          };
        } else {
          if (
            store.getState().Login.currentUserInfo &&
            store.getState().Login.currentUserInfo.accessToken
          ) {
            store.getState().OtpVerification.currentUserInfo = null;
            store.getState().InvitationHandler.accessInfo = null;

            apiConfig.headers = {
              "Content-Type": "application/json",
              Authorization:
                "Bearer " + store.getState().Login.currentUserInfo.accessToken,
            };
          } else if (
            store.getState().OtpVerification.currentUserInfo &&
            store.getState().OtpVerification.currentUserInfo.accessToken
          ) {
            store.getState().InvitationHandler.accessInfo = null
            store.getState().Login.currentUserInfo = null
            apiConfig.headers = {
              "Content-Type": "application/json",
              Authorization:
                "Bearer " +
                store.getState().OtpVerification.currentUserInfo.accessToken,
            };
          }
        }

        // else {
        //   apiConfig.headers = {
        //     "Content-Type": "application/json",
        //     Authorization:
        //       "Bearer " +
        //       store.getState().OtpVerification.currentUserInfo.accessToken,
        //   };
        // }
      }
    }
    axios(apiConfig)
      .then((response) => {
        this.handleSuccess(response.data, function (apiResponse) {
          callback(apiResponse);
        });
      })
      .catch((error) => {
        this.handleFailure(error, function (operationInfo) {
          callback(operationInfo);
        });
      });
  }

  isNotAnonymousApi(url) {
    return this.anonymousApis.indexOf(url) === -1;
  }
  handleSuccess(data, callback) {
    if (data.error) {
      callback({
        status: OperationStatus.FAILURE,
        data: data.error.data,
        error: getAPIErrorInfo(data.error.code),
      });
    } else {
      callback({
        status: OperationStatus.SUCCESS,
        data: data,
        error: {},
      });
    }
  }

  handleFailure(error, callback) {
    let errorObj = { status: OperationStatus.FAILURE, data: {}, error: {} };
    if (error.response && error.response.status) {
      // console.log(
      //   "BaseCommunication : ErrorResponse : Status : " +
      //     JSON.stringify(error.response)
      // );
      if (error.response.data && error.response.data.error) {
        if (error.response.status === HttpStatus.UNAUTHORIZED) {
          //console.log("Got unauth error"); //Code goes for token refresh
        } else {
          errorObj.error = getAPIErrorInfo(error.response.data.error.code);
          // console.log( "BaseCommunication : ErrorResponse : Response received from getAPIResponse : " +JSON.stringify(errorObj, null, 2));
          callback(errorObj);
        }
      } else {
        //Error message get decided based on received http status
        errorObj.error = getAPIErrorInfo(error.response.status);
        callback(errorObj);
      }
    } else {
      //Status not received: Check for timeout error or form generic error
      // console.log("BaseCommunication > Received unknown error: " +JSON.stringify(error, null, 2) );
      if (error.request && error.request._timedOut) {
        errorObj.error = getAppErrorInfo(OperationStatus.REQUEST_TIMEOUT);
      } else if (error.request) {
        errorObj.error = getAppErrorInfo(OperationStatus.NETWORK_NOT_REACHABLE);
        errorObj.status = OperationStatus.NETWORK_NOT_REACHABLE;
        callback(errorObj);
      } else {
        errorObj.error = getAppErrorInfo(OperationStatus.FAILURE);
      }
      callback(errorObj);
    }
    // console.log(
    //   "BaseCommunication : Parsed Error Response : " +
    //     JSON.stringify(errorObj, null, 2)
    // );
    // callback(errorObj);
  }
}
